/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedGeodesistUpdateRequest } from '../types/PatchedGeodesistUpdate';
import type { GeodesistUpdateResponse } from '../types/GeodesistUpdate';

export type GeodesistsPartialUpdateRequest = PatchedGeodesistUpdateRequest;
export type GeodesistsPartialUpdateResponse = GeodesistUpdateResponse;

export type GeodesistsPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this geodesist.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/geodesists/{id}/
 *
 * ```yaml
 * operationId: geodesists_partial_update
 * tags:
 *   - geodesists
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedGeodesistUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedGeodesistUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedGeodesistUpdate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/GeodesistUpdate'
 *     description: ''
 * ```
 */
export const geodesistsPartialUpdateOperation = ({ id, ...rest }: GeodesistsPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/geodesists/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/geodesists/{id}/' };
  };

/**
 * PATCH /dmx-server/geodesists/{id}/
 *
 * ```yaml
 * operationId: geodesists_partial_update
 * tags:
 *   - geodesists
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedGeodesistUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedGeodesistUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedGeodesistUpdate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/GeodesistUpdate'
 *     description: ''
 * ```
 */
export const geodesistsPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: GeodesistsPartialUpdateQuery;
  request: PatchedGeodesistUpdateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<GeodesistUpdateResponse>> => {
  const operation = geodesistsPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
